module.exports = __webpack_public_path__ + "static/media/irriterad.72c18845.mp3";